import { Injectable } from '@angular/core';
import { point, polygon, Feature, FeatureCollection, Point, Geometry } from '@turf/helpers';
import buffer from '@turf/buffer';
import { toWgs84 } from '@turf/projection';
import centroid from '@turf/centroid';
import pointsWithinPolygon from '@turf/points-within-polygon';
import bbox from '@turf/bbox';
import convex from '@turf/convex';

@Injectable({
  providedIn: 'root'
})
export class TurfHelperService {
  constructor() { }
  
  getBufferGeoJSON(lat: number, lng: number, radioKm:number) {
    var pt = point([lng, lat]);
    var buffered = buffer(pt, radioKm, {units: 'kilometers'});
    var converted = toWgs84(buffered);
    return buffered;
  }

  getPolygonGeoJSON(polygonPoints: number[][]) {
    polygonPoints.push(polygonPoints[0]);
    var poly = polygon([polygonPoints]);
    poly.properties = {Status: "1"};
    var converted = toWgs84(poly);
    return poly;
  }

  getCentroidGeoJSON(polygonPoints: number[][]) {
    var poly = polygon([polygonPoints]);
    var center = centroid(poly);
    var converted = toWgs84(center);
    return center;
  }

  getFeatureCentroidGeoJSON(feature: Feature) {
    var center = centroid(feature);
    return center;
  }

  getPointsWithinPolygon(points: any, area: any): FeatureCollection<Point> {
    return pointsWithinPolygon(points, area);
  }

  public getBounds(markers: any){
    var bounds = bbox(markers);
    return bounds;
  }

  CreatePolygonFromCoordinates(coordinates: number[][]): Feature {
    coordinates.push(coordinates[0]);
    var poly = polygon([coordinates]);
    poly.properties = {Status: "1"};
    var converted = toWgs84(poly);
    return poly;
  }

  GetConvexHull(coordinates: number[][]): Feature | null {
    const points: FeatureCollection<Point> = {
      type: 'FeatureCollection',
      features: coordinates.map(coord => point(coord))
    };
    
    const hull = convex(points as any);
    return hull;
  }

}
